import React from 'react';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import styles from './LoadingOverlay.module.css';

interface Props {
  label?: string;
}

const LoadingOverlay = React.memo(({label}: Props) => (
  <div className={styles.overlay}>
    <LoadingSpinner size={48} />
    {label && <p className={styles.label}>{label}</p>}
  </div>
));

export default LoadingOverlay;
